// extracted by mini-css-extract-plugin
module.exports = {"container":"_b4529e5","value":"_e6a0524","bonusCash":"_9c79ee3"};